import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import styles from './MobileNavbarButton.scss';

const propTypes = {
  toggleNav: PropTypes.func.isRequired,
  navExpanded: PropTypes.bool.isRequired,
};

const MobileNavbarButton = ({ toggleNav, navExpanded }) => (
    <Button
      id="toggleButton"
      className={styles.mobileNavButton}
      onClick={toggleNav}
      variant="default"
      label="Menu"
    >
      <div
        className={navExpanded ? styles.menuIconOpen : styles.menuIconClose}
        id="iconContainer"
      >
        <div className={styles.bar} />
        <div className={styles.bar} />
        <div className={styles.bar} />
      </div>
    </Button>
);

MobileNavbarButton.propTypes = propTypes;

export default MobileNavbarButton;
